import Api from "../api";
import {
  GET_OWNED_BLOCKED_CONTACT,
  OWN_BLOCKED_CONTACT_URL,
  DELETE_BLOCK_CONTACT,
  BLOCK_CONTACT,
} from "../lib/constant";
import { handleAPIDispatch } from "../lib/utils";

// All calls hit the new combird BlockedNumberService at
// /api/v1/me/blockednumbers (GET/POST/DELETE). These are NOT legacy URLs, so
// Api sends the OIDC access token (getAuthToken); combird derives the tenant
// from that token — no org id in the URL.

export function getOwnedBlockedContact() {
  const request = Api.get(OWN_BLOCKED_CONTACT_URL);
  return handleAPIDispatch(request, GET_OWNED_BLOCKED_CONTACT);
}

export function addBlockNumber(params) {
  const request = Api.post(OWN_BLOCKED_CONTACT_URL, params);
  return handleAPIDispatch(request, BLOCK_CONTACT);
}

export function deleteBlockNumber(params) {
  // DELETE with the number list in the body (allow_delete_body).
  const request = Api.deleteWithData(OWN_BLOCKED_CONTACT_URL, params);
  return handleAPIDispatch(request, DELETE_BLOCK_CONTACT);
}
